import styled from 'styled-components';

export const SignInH5PWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: #00416a;
  padding: 10px;
  background-image: url('${process.env
    .REACT_APP_STATIC_URL}content/assets/images/background-login.png');
  background-size: cover;
  background-position: center;

  .login-guide {
    color: #00416a;
    text-decoration: underline;

    &:hover {
      color: #00416a !important;
      text-decoration: none;
    }
  }

  .image-login {
    height: 300px;
    @media (min-width: 1025px) {
      height: 500px;
    }
  }

  .container-login {
    width: 100%;
    @media (min-width: 1025px) {
      width: 500px;
    }
  }
`;

export const StyleCheckboxRadio = styled.div`
  .radio-group {
    transition: all 0.1s ease;

    input[type='radio']:checked + label {
      background-color: #00416a;
      box-shadow: 0 0 10px 0 rgb(0 45 255 / 40%);
    }

    input[type='radio'] {
      accent-color: #ffffff;
    }

    label {
      background-color: #9AC4E0;
      color: #fff;
      display: flex;
      align-items: center;
    }

    &:hover {
      opacity: 0.75;
      // transform: translateY(-3px);
    }
`;

export const LoginButton = styled.button`
  padding: 10px 40px;
  background-color: #00416a;
  color: #fff;
  font-weight: bold;
  border-radius: 30px;
  border: none;
  box-shadow: 0 0 10px 0 rgb(0 45 255 / 40%);
  font-size: 16px;
  transition: all 0.3s ease;

  margin: auto;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover {
    box-shadow: 0 0 15px 0 rgb(0 45 255 / 40%);
    opacity: 0.8;
  }

  &:disabled {
    background-color: #545e77;
    cursor: not-allowed;
  }
`;
